import React from "react";
import { useNavigate } from "react-router-dom";
import HasMailingAddressForm from "../Forms/HasMailingAddressForm";
import { useDispatch } from "react-redux";
import { changeStep } from "../store/settings/settingsSlice";
import { updateRegistrant } from "../store/registrant/registrantSlice";
import BackButton from "../Components/BackButton";
import { getContent } from "../content";

function HasMailingAddress() {
    let navigate = useNavigate();
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(changeStep([4, 6]));
    }, []);

    const onSubmit = (data) => {
        dispatch(updateRegistrant({
            has_mailing_address: data.has_mailing_address
        }));

        if (data.has_mailing_address == 'no') {
            navigate('/additional-questions');
        } else {
            navigate('/mailing-address');
        }
    };

    return (
        <section className="flex flex-col gap-4">
            <div className="">
                <BackButton onClick={() => navigate(-1)} />
                <h2 className="my-4 md:mt-8 lg:my-16">{getContent('has_mailing_address.heading')}</h2>
            </div>
            <div className="">
                <div className="border-4 border-evcpa-darkpurple rounded-lg p-8">
                    <HasMailingAddressForm submit={onSubmit} />
                </div>
            </div>
        </section>
    );
}

export default HasMailingAddress;